<template>
  <div align="left">
    <v-container fluid fill-height>
      <Snackbar :SnackBarComponent="SnackBarComponent" />
      <v-layout align-center justify-center>
        <v-flex>
          <v-toolbar
            dense
            color="blueColorVariant9"
            class="white--text font-weight-bold fontsize20px d-flex align-center justify-center"
            ><v-img
              src="@/assets/MIHS_logo/MIHS_logo.png"
              width="30px"
              class="mr-4"
            ></v-img
            >MAKE IT HOME SAFE
          </v-toolbar>
          <v-row no-gutters justify="center">
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="8"
              class="py-2"
              v-if="
                $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
              "
            >
              <!-- <v-img src="@/assets/Car_Image.jpg" cover height="650px"></v-img> -->
              <!-- <v-card
                class="elevation-0"
                color="transparent"
                :height="smallCardHeight"
              ></v-card> -->
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" align="center">
              <!-- <v-card
                class="elevation-0"
                color="transparent"
                :height="smallCardHeight"
              ></v-card> -->
              <v-card
                color="#F9F6EE"
                max-width="380px"
                height="530px"
                class="elevation-0 mx-2 mt-14"
                align="center"
              >
                <v-card-title>
                  <v-row no-gutters>
                    <v-col cols="12" class="py-0" align="center">
                      <v-img
                        src="@/assets/MIHS_logo/MIHS_logo.png"
                        class="mt-3"
                        width="50px"
                      ></v-img>
                      <div class="pt-2">
                        {{ currentTitle }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="py-0">
                  <v-window v-model="loginStepper" class="px-3">
                    <!-- Start Of loginStepper 1 -->
                    <v-window-item :value="1">
                      <v-card-text>
                        <v-form ref="form" @submit.prevent lazy-validation>
                          <v-text-field
                            outlined
                            dense
                            class="borderRadius field_height field_label_size fontsize12px"
                            @keydown.space="preventLeadingSpace"
                            @keydown.enter="ValidateSignUpForm()"
                            v-model="Login.EmailID"
                            required
                          >
                            <!-- :rules="[(v) => !!v || 'Email ID is required']" -->
                            <template v-slot:prepend-inner>
                              <v-icon small color="primary">mdi-email</v-icon>
                            </template>
                            <template v-slot:label>
                              <div class="fontsize11px mt-n1 black--text ml-2">
                                Email ID *
                              </div>
                            </template>
                          </v-text-field>
                          <!-- <div class="mt-n3">
                            --------------OR---------------
                          </div>
                          <v-text-field
                            outlined
                            dense
                            class="borderRadius field_height field_label_size fontsize12px mt-2"
                            required
                            v-model="Login.Phone_Number"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small color="primary"
                                >mdi-page-layout-footer</v-icon
                              >
                            </template>
                            <template v-slot:label>
                              <div class="fontsize11px mt-n1 black--text ml-2">
                                Mobile number *
                              </div>
                            </template>
                          </v-text-field> -->
                          <!-- <v-text-field
                            outlined
                            dense
                            label="Password *"
                            class="borderRadius field_height field_label_size fontsize12px"
                            :type="isPwdLogin ? 'text' : 'password'"
                            @click:append="isPwdLogin = !isPwdLogin"
                            @keydown.space="preventLeadingSpace"
                            @keydown.enter="ValidateSignUpForm()"
                            required
                            :append-icon="
                              isPwdLogin ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            prepend-inner-icon="mdi-lock"
                            :rules="[(v) => !!v || 'Password is required']"
                            v-model="Login.Password"
                          ></v-text-field> -->
                        </v-form>
                      </v-card-text>
                      <!-- <v-card-actions class="py-0">
                        <v-checkbox
                          dense
                          class="my-0 py-0 ml-1"
                          v-model="rememberme"
                          label="Remember Me"
                          :disabled="
                            Login.EmailID === '' && Login.Password === ''
                          "
                        />
                        <v-spacer></v-spacer>
                        <v-btn
                          x-small
                          text
                          class="fontSize mb-4"
                          color="primary text-capitalize fontStyle"
                          @click="loginStepper = 3"
                          >Forgot Password ?</v-btn
                        >
                      </v-card-actions> -->
                      <v-card-actions class="px-4">
                        <v-btn
                          block
                          :loading="loading"
                          tile
                          class="borderRadius fontStyle"
                          color="primary"
                          @click="ValidateSignUpForm()"
                          >Login</v-btn
                        >
                      </v-card-actions>
                      <div class="fontsize12px font-weight-black mt-16">
                        <i>Don't have an account?</i>
                        <v-btn
                          x-small
                          outlined
                          color="primary"
                          class="text-capitalize mt-n1 ml-2"
                          @click="loginStepper = 5"
                          >Sign up</v-btn
                        >
                      </div>
                    </v-window-item>
                    <!-- End Of loginStepper 1 -->
                    <!-- Start Of loginStepper 2 -->
                    <!-- <v-window-item :value="2">
                      <v-card-text>
                        <v-form ref="formCP" lazy-validation>
                          <v-text-field
                            class="borderRadius field_height field_label_size fontsize12px"
                            outlined
                            dense
                            label="Enter New Password *"
                            :type="isPwdNew ? 'text' : 'password'"
                            @click:append="isPwdNew = !isPwdNew"
                            required
                            :append-icon="isPwdNew ? 'mdi-eye' : 'mdi-eye-off'"
                            prepend-inner-icon="mdi-lock"
                            :rules="[(v) => !!v || 'Password is required']"
                            v-model="Password.NewPassword"
                          ></v-text-field>
                          <v-text-field
                            class="borderRadius field_height field_label_size fontsize12px"
                            outlined
                            dense
                            label="Confirm New Password *"
                            :type="isPwdConfirm ? 'text' : 'password'"
                            @click:append="isPwdConfirm = !isPwdConfirm"
                            required
                            :append-icon="
                              isPwdConfirm ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            prepend-inner-icon="mdi-lock"
                            :rules="[(v) => !!v || 'Password is required']"
                            v-model="Password.ConfirmPassword"
                          ></v-text-field>
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="">
                        <v-col>
                          <v-btn
                            block
                            :loading="loading"
                            tile
                            class="borderRadius fontStyle"
                            color="primary"
                            @click="ValidateConfirmPasswordForm()"
                            >Login</v-btn
                          >
                          <v-btn
                            outlined
                            block
                            tile
                            class="borderRadius fontStyle mt-3"
                            color="primary"
                            @click="loginStepper = 1"
                            >Back to Sign In</v-btn
                          >
                        </v-col>
                      </v-card-actions>
                    </v-window-item> -->
                    <!-- End Of loginStepper 2 -->
                    <!-- Start Of loginStepper 3 -->
                    <!-- <v-window-item :value="3">
                      <v-card-text>
                        <v-form ref="formOTP">
                          <div class="text-center">
                            Please Enter The Registered Email
                          </div>
                          <v-text-field
                            dense
                            outlined
                            label="Email"
                            v-model="OTPEmail"
                            :rules="[(v) => !!v || 'Email ID is required']"
                            class="mt-4 borderRadius field_height field_label_size fontsize12px"
                          >
                          </v-text-field>
                          <div class="fontSize text-center">
                            *Please enter the e-mail used for login/registration
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          color="primary fontStyle"
                          small
                          @click="loginStepper = 1"
                          >Back To Sign In</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary fontStyle"
                          small
                          @click="ValidateOTP()"
                          >Next</v-btn
                        >
                      </v-card-actions>
                    </v-window-item> -->
                    <!-- End Of loginStepper 3 -->
                    <!-- Start Of Step 4 -->
                    <v-window-item :value="4">
                      <v-card-text>
                        <v-form ref="formConfirmOTP">
                          <div class="text-center">
                            Enter the OTP Sent to
                            <span class="font-weight-bold black--text">{{
                              this.$store.getters.get_user_email
                            }}</span>
                          </div>
                          <!-- <v-text-field
                            dense
                            outlined
                            label="Code *"
                            v-model="ConfirmOTP"
                            :rules="[(v) => !!v || 'Code is required']"
                            class="mt-4 borderRadius"
                          >
                          </v-text-field> -->
                          <v-otp-input
                            ref="otpInput"
                            dense
                            length="6"
                            required
                            :rules="[(v) => !!v || 'OTP is required']"
                            v-model="ConfirmOTP"
                            @finish="ValidateEnteredOTP()"
                            class="mt-4"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon color="primary">mdi-lock</v-icon>
                            </template>
                          </v-otp-input>
                          <!-- <v-text-field
                            dense
                            outlined
                            label="Enter New Password *"
                            v-model="ConfirmNewPassword"
                            :rules="[(v) => !!v || 'Password is required']"
                            class="borderRadius field_height field_label_size fontsize12px mt-4"
                            :type="isPwdConfirmCode ? 'text' : 'password'"
                            @click:append="isPwdConfirmCode = !isPwdConfirmCode"
                            required
                            :append-icon="
                              isPwdConfirmCode ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            prepend-inner-icon="mdi-lock"
                          >
                          </v-text-field> -->
                          <!-- <div class="fontSize text-center">
                            Enter the MakeItHomeSafe Activation Code sent to
                            your registered Email.
                          </div> -->
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="mt-2">
                        <v-btn
                          color="primary"
                          class="fontStyle borderRadius"
                          text
                          small
                          outlined
                          @click="loginStepper = 1"
                          >Change Email</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          small
                          outlined
                          dark
                          @click="ValidateSignUpForm()"
                          ><v-icon small>mdi-refresh</v-icon>Resend OTP</v-btn
                        >
                      </v-card-actions>
                      <v-card-actions class="mt-2">
                        <v-btn
                          color="primary"
                          class="fontStyle borderRadius"
                          block
                          dark
                          :loading="loadingLogin"
                          @click="ValidateEnteredOTP()"
                          >login</v-btn
                        >
                      </v-card-actions>
                    </v-window-item>
                    <!-- End Of Step 4-->
                    <!-- Start Of Step 5 -->
                    <v-window-item :value="5">
                      <v-card-text class="text-left py-0">
                        <v-form ref="formSignUp">
                          <!-- <div
                            class="fontsize12px my-2 font-weight-bold"
                            align="center"
                          >
                            Please Fill The Following Details
                          </div> -->
                          <v-card
                            width="100%"
                            class="elevation-0 mb-2"
                            align="center"
                            color="#F9F6EE"
                          >
                            <!-- <div class="fontsize12px text-left">
                              Profile Pic *
                            </div> -->
                            <v-card
                              width="100px"
                              height="80px"
                              @click="checkImagePresent()"
                              color="#cccccc"
                            >
                              <v-fab-transition v-if="imgSrc != ''">
                                <v-btn
                                  absolute
                                  icon
                                  top
                                  right
                                  dark
                                  x-small
                                  fab
                                  color="red"
                                  class="mt-3 mr-n5"
                                  @click.stop="
                                    (imgSrc = ''), (uploadedImage = false)
                                  "
                                >
                                  <v-icon>mdi-close-circle</v-icon>
                                </v-btn>
                              </v-fab-transition>
                              <v-img
                                contain
                                v-if="imgSrc && imgSrc != ''"
                                :src="imgSrc"
                                :lazy-src="imgSrc"
                                max-width="100px"
                                height="80px"
                              ></v-img>
                              <div v-else>
                                <input
                                  ref="image-upload-input"
                                  accept="image/*"
                                  capture="user"
                                  class="image-upload-input"
                                  type="file"
                                  @change="handleClick"
                                />
                                <v-icon class="mt-8">mdi-upload</v-icon>
                                <div class="fontsize8px">Upload Image</div>
                              </div>
                            </v-card>
                          </v-card>
                          <v-text-field
                            dense
                            outlined
                            v-model="sign_up.user_name"
                            :rules="[(v) => !!v || 'Required']"
                            class="borderRadius field_height field_label_size fontsize12px mt-5"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small color="primary">mdi-account</v-icon>
                            </template>
                            <template v-slot:label>
                              <div class="fontsize11px mt-n1 black--text ml-2">
                                Name *
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            dense
                            outlined
                            v-model="sign_up.user_email_id"
                            :rules="[
                              (v) => !!v || 'Required',
                              (v) => /.+@.+/.test(v) || 'Email Must Be Valid',
                            ]"
                            class="borderRadius field_height field_label_size fontsize12px"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small color="primary">mdi-email</v-icon>
                            </template>
                            <template v-slot:label>
                              <div class="fontsize11px mt-n1 black--text ml-2">
                                Email ID *
                              </div>
                            </template>
                          </v-text-field>
                          <!-- <v-text-field
                            dense
                            outlined
                            class="borderRadius field_height field_label_size fontsize12px"
                            v-model="sign_up.phone_number"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small color="primary"
                                >mdi-page-layout-footer</v-icon
                              >
                            </template>
                            <template v-slot:label>
                              <div class="fontsize11px mt-n1 black--text ml-2">
                                Mobile number *
                              </div>
                            </template>
                          </v-text-field> -->
                          <!-- <v-text-field
                            dense
                            outlined
                            label="Password *"
                            v-model="sign_up.password"
                            :rules="[(v) => !!v || 'Required']"
                            class="borderRadius field_height field_label_size fontsize12px"
                          >
                          </v-text-field>
                          <div class="mt-n5 fontsize10px font-weight-bold">
                            Min. 8 Characters
                          </div> -->
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="mx-2">
                        <v-btn
                          tile
                          small
                          block
                          color="primary"
                          @click="validateSignUpMethod()"
                          :loading="loading"
                          >Sign Up</v-btn
                        >
                      </v-card-actions>
                      <v-btn
                        text
                        color="primary"
                        class="fontStyle borderRadius text-capitalize"
                        small
                        @click="loginStepper = 1"
                        ><u>Back To Sign In</u></v-btn
                      >
                    </v-window-item>
                    <!-- End Of Step 4-->
                  </v-window>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Snackbar from "@/components/Extras/Snackbar.vue";
import { GenerateUploadURL } from "@/mixins/UploadImageURL.js";

import { Auth } from "aws-amplify";
export default {
  components: {
    Snackbar,
  },
  mixins: [GenerateUploadURL],
  data: () => ({
    imgSrc: "",
    OTPEmail: "",
    ConfirmOTP: "",
    ConfirmNewPassword: "",

    loadingLogin: false,
    loading: false,
    isPwdNew: false,
    isPwdLogin: false,
    rememberme: false,
    isPwdConfirm: false,
    uploadedImage: false,
    modify_boolean: false,
    isPwdConfirmCode: false,

    loginStepper: 1,
    smallCardHeight: 0,

    Login: {
      EmailID: "",
      Password: "",
      Phone_Number: "",
    },
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    sign_up: {
      user_name: "",
      user_email_id: "",
      phone_number: "",
    },
    selectedFile: {},
    SnackBarComponent: {},

    countryCodeItems: [
      { country_name: "India", country_code: "+91" },
      { country_name: "USA", country_code: "+1" },
    ],
  }),
  watch: {
    rememberme(val) {
      if (val == true) {
        localStorage.setItem("currentuseremail", JSON.stringify(this.Login));
      } else if (val == false) {
        delete localStorage.currentuseremail;
      }
    },
    loginStepper(newValue) {
      if (newValue === 4) {
        setTimeout(() => {
          this.focusOtpInput();
        }, 500);
      }
    },
  },
  computed: {
    currentTitle() {
      switch (this.loginStepper) {
        case 1:
          return "Sign In";
        case 2:
          return "Change Temporary Password";
        case 3:
          return "Forgot Password ?";
        case 4:
          return "Validate OTP";
        case 5:
          return "Sign Up";
        // default:
        //   return "Account created";
      }
    },
  },
  mounted() {
    this.smallCardHeight = window.innerHeight - 680;
    this.CheckRememberMe();
    this.checkRouteCondition();
  },
  methods: {
    focusOtpInput() {
      this.$nextTick(() => {
        const otpInputElement = this.$refs.otpInput.$el.querySelector("input");
        if (otpInputElement) {
          otpInputElement.focus();
        }
      }, 500);
    },
    handleClick(e) {
      this.Uploading = true;
      const key = `${e.target.files[0].name}`;
      this.selectedFiles = e.target.files[0];
      this.GenerateUploadURLMethods(key, this.selectedFiles);
    },
    calculateSize(img, maxWidth, maxHeight) {
      let width = img.width;
      let height = img.height;
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
      }
      return [width, height];
    },
    checkImagePresent() {
      if (this.imgSrc || this.imgSrc == "") {
        this.$refs["image-upload-input"].click();
      }
    },
    checkRouteCondition() {
      let routeparam = this.$route.name.toLowerCase();
      switch (routeparam) {
        case "signup":
          this.loginStepper = 5;
          break;
        case "Signin":
          this.loginStepper = 1;
          break;
      }
    },
    validateSignUpMethod() {
      if (this.$refs.formSignUp.validate()) {
        this.signUpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Invalid Input",
        };
      }
    },
    async signUpMethod(key, file) {
      try {
        this.loading = true;
        let config = {
          method: "post",

          // url: "https://95nzp766ce.execute-api.us-east-1.amazonaws.com/user/signIn",
          url: "https://m4yvvvbv90.execute-api.us-east-1.amazonaws.com/prod/signup",
          data: JSON.stringify({
            user_name: this.sign_up.user_name,
            user_email_id: this.sign_up.user_email_id.toLowerCase(),
            // user_phone_number: this.sign_up.phone_number.trim(),
            user_image: this.imgSrc,
            command: "newUserSignUp",
          }),
          headers: {
            "Content-Type": "application/json",
          },
        };
        const result = await axios(config);

        console.log("result", result);

        if (result.data.data.status === 200) {
          console.log("result", result);
          this.loading = false;
          this.loginStepper = 1;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Account created Successfully",
          };
        }
      } catch (error) {
        this.loading = false;
        console.log("Bug", error);
      }
    },

    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    CheckRememberMe() {
      if (localStorage.getItem("currentuseremail") != null) {
        this.Login = JSON.parse(localStorage.getItem("currentuseremail"));
        this.rememberme = true;
      }
    },
    async ConfirmOTPMethod() {
      try {
        this.loadingLogin = true;
        await Auth.sendCustomChallengeAnswer(this.user, this.ConfirmOTP).then(
          (res) => {
            if (res.attributes.email_verified == undefined) {
              this.loadingLogin = false;
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: "Invalid OTP Entered",
              };
            } else {
              this.ActivateMethod();
              this.loadingLogin = false;
            }
          }
        );
      } catch (error) {
        this.loadingLogin = false;
        console.log("OTP error", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    ValidateEnteredOTP() {
      if (this.$refs.formConfirmOTP.validate()) {
        this.ConfirmOTPMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter The Code Sent To Registered Email",
        };
      }
    },
    ValidateOTP() {
      if (this.$refs.formOTP.validate()) {
        this.SendOTPEmail();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter Registered Email",
        };
      }
    },
    SendOTPEmail() {
      Auth.forgotPassword(this.OTPEmail.trim())
        .then(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "OTP Sent To Registered Email",
          };
          this.loginStepper = 4;
        })
        .catch((err) => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: err.message,
          };
        });
    },
    async ConfirmPassword() {
      try {
        this.loading = true;
        const result = await Auth.completeNewPassword(
          this.user,
          this.Password.ConfirmPassword.trim()
        )
          .then((user) => {
            return user;
          })
          .catch((e) => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: e,
            };
            return e;
          });
        if (result.username) {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Successful",
          };
          this.$refs.formCP.reset();
          this.ActivateMethod();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    async SignIn() {
      try {
        this.loading = true;
        let SignIN_Details = "";
        if (this.Login.EmailID != "") {
          SignIN_Details = this.Login.EmailID.trim();
        } else if (this.Login.Phone_Number != "") {
          SignIN_Details = this.Login.Phone_Number.trim();
        }
        const user = await Auth.signIn(
          SignIN_Details
          // username: this.Login.Phone_Number,
          // attributes: { user_phone_number: this.Login.Phone_Number },
        );
        console.log("mira", user);
        this.user = user;

        if (user.challengeName === "CUSTOM_CHALLENGE") {
          this.loginStepper = 4;
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "OTP Sent Successfully!!",
          };
          if (this.Login.EmailID != "") {
            this.$store.commit("SET_USEREMAIL", this.Login.EmailID);
          } else if (this.Login.Phone_Number != "") {
            this.$store.commit("SET_PHONENUMBER", this.Login.Phone_Number);
          }
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Invalid Credentials!!",
          };
          this.ActivateMethod();
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        if (error.message == "User is disabled.") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "You Are Currently Inactive",
          };
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.message,
          };
        }
      }
    },
    ActivateMethod() {
      this.$store.commit("SET_AUTH", true);
      this.$store.commit("SET_CURRENT_LOCATION", true);
      setTimeout(() => this.$router.push("/PlateLookUp"), 500);
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        Top: true,
        SnackbarText: "Login Successful",
      };
    },
    ValidateConfirmPasswordForm() {
      if (this.$refs.formCP.validate()) {
        if (this.Password.NewPassword == this.Password.ConfirmPassword) {
          this.ConfirmPassword();
        } else {
          this.$refs.form.reset();
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Password does not match",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
      }
    },
    ValidateSignUpForm() {
      if (this.$refs.form.validate()) {
        this.SignIn();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Enter E-mail",
        };
      }
    },
  },
};
</script>
